import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../Translations/LenguageContext";
import { TbGalaxy } from "react-icons/tb";
import Spinner from "../Components/Spinner";

function Navbar({ title }) {
    const navigate = useNavigate();
    const [scrolled, setScrolled] = useState(false);
    const { t } = useLanguage();
    const [loading, setLoading] = useState(false)
    const [err, setErr] = useState({ message: "", display: false });
    const [rememberUser, setRememberUser] = useState(null)
    const [isMobile, setIsMobile] = useState(false);

    function getCookie(name) {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (match) {
            return match[2];
        }
        return null;
    }

    useEffect(() => {
        setRememberUser(getCookie("erioon"));


        const handleScroll = () => {
            if (window.scrollY > 0) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    function DirectLogin() {
        setLoading(true);
        const dataToSend = {
            _id: rememberUser,
        };

        fetch('https://backend.erioon.com/direct_login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataToSend),
        })
            .then(response => response.json())
            .then(data => {
                setLoading(false);
                if (data.message === "OK") {
                    const db_id = data.user_id;
                    sessionStorage.setItem("user_id", db_id);
                    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

                    if (isMobile) {
                        navigate("/mobile_device");
                    } else {
                        navigate("/control_panel/projects");
                    }
                } else {
                    navigate("/login");
                }
            })
            .catch(error => {
                setLoading(false);
                setErr({ message: t.register_form.problem_back, display: true });
            });
    }

    const GoLogo = () => {
        navigate("/logo")
    }

    const navigateUrl = () => {
        window.location.href = "https://t0.erioon.com/join-waitlist";
    }

    return (
        <div className={`main_navbar ${scrolled ? "scrolled" : ""}`}>
            <div className="navbar">
                <div className="nav_cont_1">
                    <a href="/">
                        <p id="title_navbar">
                            <i><TbGalaxy /></i>
                            Erioon
                            <span>{title}</span>
                        </p>
                    </a>
                </div>
                <div className="nav_cont_1">
                    <div>
                        {rememberUser ? (
                            isMobile ? (
                                <button className="waitin_list_btn" onClick={() => GoLogo()}>
                                    {loading ? (
                                        <Spinner loading={loading} />
                                    ) : (
                                        <>
                                            Dashboard <i className="fa-solid fa-arrow-right"></i>
                                        </>
                                    )}
                                </button>
                            ) : (
                                <button className="waitin_list_btn" onClick={() => DirectLogin()}>
                                    {loading ? (
                                        <Spinner loading={loading} />
                                    ) : (
                                        <>
                                            Dashboard <i className="fa-solid fa-arrow-right"></i>
                                        </>
                                    )}
                                </button>
                            )

                        ) : (
                            <div className={`register_btn_nav_cont ${scrolled ? "register_btn_nav_scrolled_cont" : ""}`}>
                                {/* <button className="login_btn" onClick={() => navigate("/login")}>
                                    Login <i className="fa-solid fa-login"></i>
                                </button> */}
                                 {/*<button className="start_now_btn" onClick={() => navigate("/register")}>
                                    Sart now
                                </button> */}
                                <button className="start_now_btn" onClick={navigateUrl}>
                                    Join waitlist
                                </button>
                                {/* <button className="start_now_btn" onClick={() => navigate("/register")}>
                                    Start now
                                </button> */}
                            </div>
                        )}

                    </div>
                </div>
            </div>
        </div>
    );
}

export default Navbar;
